export enum ExpressCheckoutErrorLogKeys {
  EXPRESS_CHECKOUT_SUBMIT_ERROR = 'EXPRESS_CHECKOUT_SUBMIT_ERROR',
  EXPRESS_CHECKOUT_OPEN_ERROR = 'EXPRESS_CHECKOUT_OPEN_ERROR',
}
